import { replaceReferenceMutator } from "./replaceReferenceMutator.js";
import {} from "./types.js";
/**
 * Rate limit the mutator of a reference using a the given rate limiter.
 *
 * @public
 */
export function rateLimitMutatorRef(
/**
 * The reference to wrap. The mutator of this reference will be replaced with
 * a rate limited version of itself.
 */
origin, 
/**
 * A function that takes a mutator and returns a new mutator that is rate limited.
 */
rateLimiter) {
    return replaceReferenceMutator(origin, (origin$) => rateLimiter(origin$.set));
}
